import { GET_GLOBAL_STATS_FULFILLED, GET_GLOBAL_STATS_PENDING, GET_GLOBAL_STATS_REJECTED, ROUTER_BEFORE_NAVIGATE, } from 'constants/ActionTypes';
const statsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_GLOBAL_STATS_PENDING: {
            if (action.error) {
                return Object.assign(Object.assign({}, state), { fetchedAt: Date.now() });
            }
            return state;
        }
        case ROUTER_BEFORE_NAVIGATE: {
            if (!action.initial) {
                return Object.assign(Object.assign({}, state), { fetched: false });
            }
            else {
                return state;
            }
        }
        case GET_GLOBAL_STATS_FULFILLED: {
            return Object.assign(Object.assign(Object.assign({}, state), action.payload.data), { fetched: true, fetchedAt: Date.now() });
        }
        case GET_GLOBAL_STATS_REJECTED: {
            return Object.assign(Object.assign({}, state), { fetchedAt: Date.now() });
        }
        default:
            return state;
    }
};
export default statsReducer;
